import React, { useState, useEffect } from "react";
import axios from "axios";
import ProductCard from "./../../Components/ProductCard/ProductCard";
import CategoryJumbotron from "../../Components/CategoryJumbotron/CategoryJumbotron";
import { Loader } from "../../Components/Loader";

const categoryContent = {
  VME: {
    title: "VME",
    text: "Since Highland Technology entered the VME market in 1992, we have maintained a consistent commitment to VME as an open, robust, and cost-effective platform for high channel count control, measurement, and simulation systems. Highland is a member of VITA, the VME standards body, and continues to release new technology into the VME market. As other bus architectures come and go, Highland remains confident that VME will maintain its position as the architecture of choice for essential, long life cycle programs.",
    SEOTitle: "High-Performance VME Modules | Highland Technology",
    SEODesc: "Explore precision VME modules for timing, control, and measurement. Built for aerospace, defense, and research applications by Highland Technology.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/VME/",
  },
  DDG: {
    title: "DIGITAL DELAY GENERATORS",
    text: 'Highland has introduced three unique features to digital delay generation: a "Queued Updates" feature allows time settings to be changed without corrupting ongoing timings; a "Train" feature allows multiple pulses to be generated from each trigger; and a "Frames" feature allows complex delay sweeps and pulse scenarios to be pre-loaded and rapidly executed. Digital delay and pulse generators are available in 1-6 channels, with square, Gaussian, and arbitrary waveshapes, and insertion delays as low as 10 nanoseconds.',
    SEOTitle: "Digital Delay Generators | Precision Timing | Highland Technology",
    SEODesc: "Discover high-precision digital delay generators with picosecond timing accuracy for laser, test, and synchronization applications. Built by Highland Technology.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/DDG/",
  },
  PSG: {
    title: "PULSE GENERATORS",
    text: "Highland Technology pulse generators translate low-level signals with slow edges into clean, fast pulses with amplitudes of up to 100V. DC and transformer coupled models are available.",
    SEOTitle: "High-Voltage Pulse Generators | Highland Technology",
    SEODesc: "Fast rise-time high-voltage pulse generators for instrumentation, test, and aerospace applications. Explore Highland Technology’s PSG series.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/PSG/",
  },
  WFG: {
    title: "WAVEFORM GENERATORS",
    text: "Highland offers waveform generators across a wide range of forms and performance. From simple 4 channel function generators to our flagship arbitrary waveform generators with interchannel modulation, system mastering capability, and unlimited synchronization capability, all of our waveform generators are designed to allow synchronous signal generation for easy integration into end systems.",
    SEOTitle: "Waveform Generators | Arbitrary & Multi-Channel | Highland Technology",
    SEODesc: "Discover high-performance waveform generators—from 4-channel function models to fully synchronized arbitrary systems—designed by Highland Technology.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/WFG/",
  },
  LDC: {
    title: "LASER DRIVERS & CONTROLLERS",
    text: "Highland Technology offers off the shelf and OEM solutions for many laser driver and control needs including: Fast Pulse Generators for E/O Modulation, Fast Laser Diode Drivers, Seed Laser Pulse Picking, MOPA timing and control, Custom Delay and Waveform Generation, and many more!",
    SEOTitle: "Laser Drivers & Controllers | Highland Technology",
    SEODesc: "Off-the-shelf and OEM laser drivers and controllers for fast pulse generation, diode modulation, seed-laser pick-off, and MOPA timing. Built by Highland Technology.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/LDC/",
  },
  PHO: {
    title: "PHOTONICS",
    text: "Precision fiberoptic and free-space interfaces provide high-speed, low-jitter and low noise signal conversion, and transport of analog and digital signals.",
    SEOTitle: "Photonics Interfaces & Fiber-Optic Modules | Highland Technology",
    SEODesc: "High-precision fiber-optic and free-space signal interfaces: electrical-to-fiber and fiber-to-electrical conversion for high-speed, low-jitter systems by Highland Technology.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/PHO/",
  },
  EDG: {
    title: "USB/Ethernet Edge Instruments",
    text: "Highland Technology's compact, cost-effective USB and Ethernet edge instruments bring precision measurement and simulation directly to the point of use, eliminating the need for racks, card cages, and custom cabling. Applications include tachometers, inductive sensors, temperature and cryogenic measurement and simulation, rotating machinery simulation, precision delay and pulse generation, high-voltage pulsers, and laser/EOM drivers. Instruments operate from 24 VDC or Power over Ethernet (PoE), and a modular architecture allows custom functions to be developed with minimal engineering effort.",
    SEOTitle: "Edge Instrumentation for Aerospace | Highland Technology",
    SEODesc: "Explore compact Ethernet and USB edge instruments for precision measurement and simulation. Built for aerospace, defense, and research by Highland Technology.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/EDG/",
  },
  MAS: {
    title: "MEASUREMENT & SIMULATION",
    text: "Highland Technology offers a wide array of tools for measurement, simulation, and control. Tachometers, thermocouples, RTDs, precision voltages, current loops, strain gauges, and more can be measured or simulated by Highland's products.",
    SEOTitle: "Measurement & Simulation Instruments | Highland Technology",
    SEODesc: "Explore precision simulators and measurement systems—RTDs, tachometers, current loops and more—for testing aerospace, defense & industrial applications by Highland Technology.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/MAS/",
  },
  MPS: {
    title: "MODULAR POWER SYSTEM",
    text: "Highland's Modular Power System consists of a 3U rackmount enclosure with a main controller, power supply and cooling, and provision for installation of up to eight power, load, switching, or measurement modules, primarily intended for aerospace testing.",
    SEOTitle: "Modular Power System | Rack-Mount Power & Load Modules | Highland Technology",
    SEODesc: "Explore the P940 Modular Power System – a 3U rackmount platform that supports power supplies, loads, switching and measurements in aerospace & industrial testing.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/MPS/",
  },
  OEM: {
    title: "CUSTOM/OEM",
    text: "Since 1984 Highland has provided custom electronics for challenging customer applications. Areas of expertise include: Picosecond timing, Precision analog and mixed signal processing, Digital delay and pulse generation, High speed photonics and fiberoptic timing distribution, and Aerospace instrumentation and simulation. Products demonstrating these capabilities are shown here.",
    SEOTitle: "Custom & OEM Electronics Solutions | Highland Technology",
    SEODesc: "Since 1984, Highland Technology has designed and manufactured custom OEM electronics—picosecond timing, precision analog & mixed-signal, aerospace instrumentation.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/OEM/",
  },
  LEG: {
    title: "LEGACY",
    text: "Highland is committed to providing long-term availability of products and product support. The following products are not recommended for new design due to difficulty stocking components and high component costs. Highland will continue to support existing customers by producing and maintaining these designs whenever possible. New customers are encouraged to consider replacement products. Please contact our sales department to inquire about any products not shown.",
    SEOTitle: "Legacy Instrumentation & Modules | Highland Technology",
    SEODesc: "Explore long-term-supported legacy modules and instrumentation for defense and aerospace programs—Highland Technology remains committed to product life-cycle support.",
    canonicalUrl: "https://www.highlandtechnology.com/Category/LEG/",
  },
};

function getContentForCategory(categorySelected) {
  const defaultContent = {
    title: "Not Found",
    text: "The selected category does not have any content.",
    SEOTitle: "",
    SEODesc: "",
    canonicalUrl: "",
  };

  return categoryContent[categorySelected] || defaultContent;
}

const Category = () => {
  const categorySelected = window.location.href.split("/Category/")[1].substring(0, 3);

  const [categoryData, setCategoryData] = useState();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getCategoryData = async () => {
      setIsLoading(true);
      try {
        const categoryData = await axios.get(
          `/api/products/category/${categorySelected}`
        );
        setCategoryData(categoryData.data);

        // Fire custom Reddit tracking based on category
          if (window.rdt) {
            window.rdt("track", "Custom", {
              customEventName: categorySelected ? `${categorySelected}PageView` : "UnknownCategoryPageView",
            });
          }

      } catch (error) {
        console.log(error.response);
      } finally {
        setIsLoading(false);
      }
    };
    getCategoryData();

  }, [categorySelected]);

  const { title, text, SEOTitle, SEODesc, canonicalUrl } = getContentForCategory(categorySelected);

  return (
    <div>
      <CategoryJumbotron title={title} text={text} SEOTitle={SEOTitle} SEODesc={SEODesc} canonicalUrl={canonicalUrl} />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-10">
            <ProductCard categoryData={categoryData} />
          </div>
          <div className="col-md-1"></div>
        </div>
      )}
    </div>
  );
};

export default Category;
